<div [ngClass]="{'nav-width': menuView}"></div>
<div [ngClass]="{'nav-margin': menuView}"></div>
<nav *ngIf="items.length > 0" class="navbar-default navbar-static-side" role="navigation" [ngClass]="{'menu-enter': menuView, 'menu-leave': !menuView}">
  <div class="sidebar-collapse">
    <ul *ngIf="loadAllPermissions" class="nav metismenu" id="side-menu">
      <ng-container *ngFor="let item of items">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit:{
          item:item, level: 1}}">
        </ng-container>
      </ng-container>
      <ng-container *ngFor="let item of itemsLegacy">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit:{
          item:item, level: 1}}">
        </ng-container>
      </ng-container>
    </ul>
  </div>
</nav>
<ng-template #itemTemplate let-data>
  <ng-container *ngIf="data.item as item">
    <li *ngIf="hasPermission(item.permissao)"
      [ngClass]="{'mm-active': getActiveRoute(item), 'menu-label': data.level == 1}">
      <ng-container *ngIf="item.tipo_link === 'href'; else routeLink">
        <a class="mini-navbar-arrow"  [attr.aria-expanded]="item.open" 
          (click)="toggleItem(item)"  [href]="buildLinkHref(item)" 
          [ngClass]="{'has-arrow':item.menu_navegacao_filhos > 0, 'mini-navbar-arrow': data.level == 1, 'sub-mini-navbar': data.level == 2}">
          <div class="content_option">
            <div class="d-flex">
              <span class="font-icon me-1">{{item.icone}}</span>
            </div>
            <span>{{item.nome}}</span>
          </div>
        </a>
      </ng-container>
      <ng-template #routeLink>
        <a class="mini-navbar-arrow" href="#" [attr.aria-expanded]="item.open"
          (click)="toggleItem(item)" [routerLink]="buildLink(item)"
          [ngClass]="{'has-arrow':item.menu_navegacao_filhos > 0, 'mini-navbar-arrow': data.level == 1, 'sub-mini-navbar': data.level == 2}">
          <div class="content_option">
            <div class="d-flex">
              <span class="font-icon me-1">{{item.icone}}</span>
            </div>
            <span>{{item.nome}}</span>
          </div>
        </a>
      </ng-template>
      <ul class="nav " *ngIf="item.menu_navegacao_filhos && item.open" 
        [ngClass]="{'nav-second-level': data.level == 1, 'nav-second-level-2': data.level == 1, 'nav-third-level': data.level == 2, 'nav-fourth-level': data.level == 3}" class="mm-show">
        <ng-container *ngFor="let child of item.menu_navegacao_filhos">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit:{
            item:child, level: data.level + 1}}">
          </ng-container>
        </ng-container>
      </ul>
    </li>
  </ng-container>
</ng-template>